import { Typography } from "@mui/material";
import type { ColumnDef } from "@tanstack/react-table";
import type { Delivery } from "@types_def/models/delivery.types";
import { DataTableColumnHeader } from "@/components/ui/data-table-column-header";
import AdminInvoiceAction from "./CustomCells/AdminInvoiceAction";
import ContractCell from "./CustomCells/contract-cell";
import { DateCell } from "./CustomCells/DateCell";
import { DriverNameCell } from "./CustomCells/NameCell";
import OrganizationCell from "./CustomCells/OrganizationCell";
import { PriceCell } from "./CustomCells/PriceCell";

export const SUBSCRIPTION_PAYMENT_COLUMNS: ColumnDef<Delivery>[] = [
  {
    id: "publicId",
    accessorKey: "publicId",
    enableSorting: true,
    meta: { label: "Contrat" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Contrat" />,
    cell: ({ row }) => <ContractCell>{row.original}</ContractCell>,
  },
  {
    id: "organizationId",
    accessorFn: (row) => row.deliveryOrganization?.name ?? "",
    enableSorting: true,
    meta: { label: "Organisation" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Organisation" />,
    cell: ({ row }) => <OrganizationCell>{row.original.deliveryOrganization}</OrganizationCell>,
  },
  {
    id: "driver",
    accessorFn: (row) => row.accepted_offer?.driver?.fullName ?? "",
    enableSorting: false,
    meta: { label: "Driver" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Driver" />,
    cell: ({ row }) => <DriverNameCell>{row.original.accepted_offer}</DriverNameCell>,
  },
  {
    id: "completedAt",
    accessorKey: "completedAt",
    enableSorting: true,
    meta: { label: "Date" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Date" />,
    cell: ({ row }) => <DateCell>{row.original.completedAt}</DateCell>,
  },
  {
    id: "amount",
    accessorKey: "accepted_offer",
    enableSorting: false,
    meta: { label: "Montant HT" },
    header: ({ column }) => <DataTableColumnHeader column={column} title="Montant HT" />,
    cell: ({ row }) => <PriceCell>{row.original}</PriceCell>,
  },
  {
    id: "action",
    accessorKey: "id",
    enableSorting: false,
    meta: { label: "Action", align: "center" },
    header: () => <Typography variant="subtitle1">Action</Typography>,
    cell: ({ row }) => <AdminInvoiceAction>{row.original}</AdminInvoiceAction>,
  },
];
